<div>
    <ng-container>{{'Langue' | translate}}</ng-container>
    <select style="margin: 0px 10px 0px 10px" (change)="onLanguageChange($event.target.value)">
        <option *ngFor="let lang of getArrayAvailableLanguage()" [selected]="lang.shortName == getStringLocal(true)" [value]="lang.shortName">
            {{ lang.name }}
        </option>
    </select>
</div>
